import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import Label from './Label';
import ChevronDown from '../Icons/ChevronDown';
import css from './LabelDropdown.module.scss';

const LabelDropdown = ({
  dropdownList = [],
  activeLabel,
  className = '',
  onValueChange,
  color,
  backgroundColor,
  variant,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleLabelClick = (e) => {
    e.stopPropagation();
    if (dropdownList && dropdownList.length > 0) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (item) => {
    setIsOpen(false);
    if (onValueChange) {
      onValueChange(item);
    }
  };

  return (
    <div className={css.labelDropdownWrapper} ref={wrapperRef}>
      <Label
        className={className}
        onClick={handleLabelClick}
        icon={
          dropdownList && dropdownList.length > 0
            ? () => <ChevronDown width={12} height={12} />
            : null
        }
        iconPosition="right"
        style={{cursor: dropdownList && dropdownList.length > 0 ? 'pointer' : 'default'}}
        color={color}
        backgroundColor={backgroundColor}
        variant={variant}
      >
        {activeLabel}
      </Label>
      {isOpen && dropdownList && dropdownList.length > 0 &&
        <ul className={css.dropdownList}>
          {dropdownList.map((item) =>
            <li
              key={item.value}
              className={css.dropdownItem}
              onClick={() => handleOptionClick(item)}
            >
              {item.label}
            </li>
          )}
        </ul>
      }
    </div>
  );
};

LabelDropdown.propTypes = {
  dropdownList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ),
  activeLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  onValueChange: PropTypes.func,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'disabled']),
};

export default LabelDropdown;
